import { PlantLayoutEditorThemeSizeConfig } from './types';

const medium: PlantLayoutEditorThemeSizeConfig = {
  plantLayoutEditor: {},
};

export default medium;
